// Modal.js
import ReactDOM from "react-dom";

const Modal = ({ isVisible, onClose, children }) => {
  if (!isVisible) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-2 md:p-4 rounded-lg shadow-lg relative z-50 w-[90vw] md:w-[80vw] lg:w-[50vw]">
        {/* <div className="bg-white p-2 md:p-4 rounded-lg shadow-lg relative z-50 w-full md:w-[50vw]"> */}
        <button
          className="absolute top-8 right-8"
          onClick={onClose}
          aria-label="Close"
        >
          <svg
            className="h-6 w-6 text-agRed"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        {children}
      </div>
    </div>,
    document.getElementById("modal-root"), // Ensure modal-root exists in your HTML
  );
};

export default Modal;

// // Modal.js
// import React from "react";

// const Modal = ({ isVisible, onClose, children }) => {
//   if (!isVisible) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       <div className="bg-white p-8 rounded-lg shadow-lg relative z-50 w-full md:w-auto">
//         <button className="absolute top-2 right-2" onClick={onClose}>
//           <svg
//             className="h-6 w-6 text-agRed rounded-xl hover:bg-agRedBg"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M6 18L18 6M6 6l12 12"
//             ></path>
//           </svg>
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Modal;

// MODAL BEFORE NEW MODAL IMPLEMENTATION - HEADER & SIDEBAR WORKING
// // Modal.js
// import React from "react";

// const Modal = ({ isVisible, onClose, children }) => {
//   if (!isVisible) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center">
//       <div className="bg-white p-8 rounded-lg shadow-lg relative z-50">
//         <button className="absolute top-2 right-2" onClick={onClose}>
//           <svg
//             className="h-6 w-6 text-agRed rounded-xl  hover:bg-agRedBg hover: bg-rounded-sm m-1 p-1"
//             fill="none"
//             stroke="currentColor"
//             viewBox="0 0 24 24"
//             xmlns="http://www.w3.org/2000/svg"
//           >
//             <path
//               strokeLinecap="round"
//               strokeLinejoin="round"
//               strokeWidth="2"
//               d="M6 18L18 6M6 6l12 12"
//             ></path>
//           </svg>
//         </button>
//         {children}
//       </div>
//     </div>
//   );
// };

// export default Modal;
